import React, {Component} from 'react';
import NavBar from './common/NavBar';

class HelpPage extends Component {

    render () {

        return (
            <article className="container help-body">
                <main>
                    <section className="row">
                        <div className="col-xs-12 text-center">
                            <h1 className="h1">Help</h1>
                            <hr/>
                        </div>
                    </section>
                    <section className="row">
                        <nav className="col-xs-12 col-sm-3">
                            <NavBar />
                        </nav>
                        <div className="col-xs-12 col-sm-9">
                            {this.props.children}
                        </div>
                    </section>
                </main>
            </article>
        )
    }
}

export default HelpPage;


// WEBPACK FOOTER //
// src/client/components/site/features/help/HelpPage.js